export default __webpack_public_path__ + "static/media/image-placeholder.cd35960a.png";